/**
 * A "dica" que aparece ao passar o mouse (ou o foco do teclado) numa barra ou
 * num carro. O valor vem primeiro, em destaque; o resto vem embaixo.
 * A dica só complementa: todo valor também está no gráfico ou na tabela.
 *
 * Lê: nada.
 * Usado por: graficos/GraficoBarras.tsx e graficos/CorridaCarrinhos.tsx.
 */
interface Props {
  x: number;
  y: number;
  larguraDisponivel: number;
  linhas: string[];
}

const LARGURA_DICA = 230;

export function Dica({ x, y, larguraDisponivel, linhas }: Props) {
  const [principal, ...resto] = linhas;
  const esquerda = Math.max(4, Math.min(x + 12, larguraDisponivel - LARGURA_DICA - 4));
  return (
    <div className="dica" style={{ left: esquerda, top: y, width: LARGURA_DICA }} role="presentation">
      {principal ? <strong>{principal}</strong> : null}
      {resto.map((linha, i) => (
        <span key={i}>{linha}</span>
      ))}
    </div>
  );
}
